export class TaskModel {
    id: number;
    hotel_id: number;
    user_id: number;
    user_name: string;
    user_picture: string;
    email: string;
    location: string;
    note: string;
    type: string;
    assets: string;
    assignment_type: string;
    assignment_id: number;
    assignment_name: string;
    order_date: Date;
    status: string;
    staff_note: string;
    read: boolean;
    read_at: Date;
    read_by_user: string;
    in_the_process: boolean;
    in_the_process_at: Date;
    in_the_process_by_user: string;
    managed: boolean;
    managed_at: Date;
    managed_by_user: string;
    created_at: Date;

    constructor(
        id = 0,
        hotel_id = 0,
        user_id = 0,
        user_name = '',
        user_picture = '',
        email = '',
        location = '',
        note = '',
        type = '',
        assets = '',
        assignment_type = '',
        assignment_id = 0,
        assignment_name = '',
        order_date = new Date(),
        status = 'New',
        staff_note = '',
        read = false,
        read_at = new Date(0),
        read_by_user = '',
        in_the_process = false,
        in_the_process_by_user = '',
        in_the_process_at = new Date(0),
        managed = false,
        managed_at = new Date(0),
        managed_by_user = '',
        created_at = new Date()
    ) {
        this.id = id;
        this.hotel_id = hotel_id;
        this.user_id = user_id;
        this.user_name = user_name;
        this.user_picture = user_picture;
        this.email = email;
        this.location = location;
        this.note = note;
        this.type = type;
        this.assets = assets;
        this.assignment_type = assignment_type;
        this.assignment_id = assignment_id;
        this.assignment_name = assignment_name;
        this.order_date = order_date;
        this.status = status;
        this.staff_note = staff_note;
        this.read = read;
        this.read_at = read_at;
        this.read_by_user = read_by_user;
        this.in_the_process = in_the_process;
        this.in_the_process_by_user = in_the_process_by_user;
        this.in_the_process_at = in_the_process_at;
        this.managed = managed;
        this.managed_at = managed_at;
        this.managed_by_user = managed_by_user;
        this.created_at = created_at;
    }


}
